// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RaiseTicket_pageWrap__kk4vC {
  padding: 4px 4px 32px;
}

.RaiseTicket_sectionTitle__zFoP- {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #4c2fb3;
  margin: 26px 0 14px;
  padding-top: 14px;
  border-top: 1px solid #EEF0F6;
}
.RaiseTicket_sectionTitle__zFoP-:first-child {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
}

.RaiseTicket_submitRow__hBZiv {
  display: flex;
  justify-content: flex-end;
  margin-top: 28px;
}

.RaiseTicket_statusBanner__ErTE9 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #F5F3FE;
  color: #4c2fb3;
  font-weight: 700;
  font-size: 13px;
  padding: 8px 16px;
  border-radius: 10px;
  margin-bottom: 8px;
}

.RaiseTicket_resolutionCard__Kmg1f {
  border: 1px solid #EEF0F6;
  border-radius: 12px;
  background: #FAFAFD;
  padding: 16px;
}

.RaiseTicket_resolutionRow__a075V {
  display: flex;
  gap: 8px;
  font-size: 13px;
  padding: 3px 0;
}

.RaiseTicket_resolutionLabel__IR5yx {
  color: #6B7280;
  font-weight: 600;
  min-width: 100px;
  flex-shrink: 0;
}

.RaiseTicket_resolutionValue__U31Y- {
  color: #1F2430;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Raiseissue/RaiseTicket.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n.sectionTitle {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  color: #4c2fb3;\n  margin: 26px 0 14px;\n  padding-top: 14px;\n  border-top: 1px solid #EEF0F6;\n}\n.sectionTitle:first-child {\n  margin-top: 0;\n  padding-top: 0;\n  border-top: none;\n}\n\n.submitRow {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 28px;\n}\n\n.statusBanner {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #F5F3FE;\n  color: #4c2fb3;\n  font-weight: 700;\n  font-size: 13px;\n  padding: 8px 16px;\n  border-radius: 10px;\n  margin-bottom: 8px;\n}\n\n.resolutionCard {\n  border: 1px solid #EEF0F6;\n  border-radius: 12px;\n  background: #FAFAFD;\n  padding: 16px;\n}\n\n.resolutionRow {\n  display: flex;\n  gap: 8px;\n  font-size: 13px;\n  padding: 3px 0;\n}\n\n.resolutionLabel {\n  color: #6B7280;\n  font-weight: 600;\n  min-width: 100px;\n  flex-shrink: 0;\n}\n\n.resolutionValue {\n  color: #1F2430;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `RaiseTicket_pageWrap__kk4vC`,
	"sectionTitle": `RaiseTicket_sectionTitle__zFoP-`,
	"submitRow": `RaiseTicket_submitRow__hBZiv`,
	"statusBanner": `RaiseTicket_statusBanner__ErTE9`,
	"resolutionCard": `RaiseTicket_resolutionCard__Kmg1f`,
	"resolutionRow": `RaiseTicket_resolutionRow__a075V`,
	"resolutionLabel": `RaiseTicket_resolutionLabel__IR5yx`,
	"resolutionValue": `RaiseTicket_resolutionValue__U31Y-`
};
export default ___CSS_LOADER_EXPORT___;
